import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "storenotice" }
const _hoisted_2 = { class: "upload-container" }
const _hoisted_3 = { class: "upload-container" }

import { ref, reactive, onMounted, computed } from 'vue';
import { useApi } from '@/hooks/useApi';
import { ElMessage, ElMessageBox, FormInstance, FormRules, UploadRawFile } from 'element-plus';
import { useBaseAsync, useBaseUserStore } from 'hpsfir-managebase-ui';
import { StoreNoticeSpe } from '@/api';
import { Plus } from '@element-plus/icons-vue';

interface UploadResponse {
  data: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const formRef = ref<FormInstance>();
const saving = ref(false);
const resetting = ref(false);
const loading = ref(false);
const baseUserStore = useBaseUserStore();

const formData = reactive<StoreNoticeSpe>({
  store: '',
  rule: '',
});

const rules: FormRules = {
  store: [{ required: true, message: '请上传本店须知图片', trigger: 'change' }],
  rule: [{ required: true, message: '请上传规则图片', trigger: 'change' }],
};

const uploadUrl = computed(() => useApi().baseUrl + useApi().uploadFileUrl);

const uploadHeaders = computed(() => ({
  Authorization: baseUserStore.token,
}));

const getFullUrl = (url: string) => {
  if (!url) {
    return '';
  }
  if (url.startsWith('http')) {
    return url;
  }
  return useApi().baseUrl + url;
};

const beforeUpload = (file: UploadRawFile) => {
  const isImage = file.type.startsWith('image/');
  const isLt5M = file.size / 1024 / 1024 < 5;

  if (!isImage) {
    ElMessage.error('只能上传图片文件!');
    return false;
  }
  if (!isLt5M) {
    ElMessage.error('上传图片大小不能超过 5MB!');
    return false;
  }
  return true;
};

const handleStoreSuccess = (response: UploadResponse) => {
  if (response && response.data && response.data.length > 0) {
    const [url] = response.data;
    formData.store = url;
    ElMessage.success('本店须知图片上传成功');
  }
};

const handleRuleSuccess = (response: UploadResponse) => {
  if (response && response.data && response.data.length > 0) {
    const [url] = response.data;
    formData.rule = url;
    ElMessage.success('规则图片上传成功');
  }
};

// 加载配置
const loadConfig = useBaseAsync(async() => {
  loading.value = true;
  try {
    const res = await useApi().storeNoticeApi.getStoreNoticestoreNotice();
    const { data } = res.data;
    if (data) {
      formData.store = data.store || '';
      formData.rule = data.rule || '';
    }
  } finally {
    loading.value = false;
  }
});

// 保存配置
const handleSave = useBaseAsync(async() => {
  await formRef.value?.validate();
  saving.value = true;
  try {
    await useApi().storeNoticeApi.updateStoreNoticestoreNotice({
      storeNotice: {
        store: formData.store,
        rule: formData.rule,
      },
    });
    ElMessage.success('保存成功');
  } finally {
    saving.value = false;
  }
});

// 重置为默认
const handleReset = async() => {
  await ElMessageBox.confirm('确定要重置为默认配置吗？', '提示', {
    type: 'warning',
    confirmButtonText: '确认',
    cancelButtonText: '取消',
  });
  resetting.value = true;
  try {
    await useApi().storeNoticeApi.updateStoreNoticestoreNotice({
      storeNotice: {
        store: '',
        rule: '',
      },
    });
    ElMessage.success('重置成功');
    await loadConfig();
  } finally {
    resetting.value = false;
  }
};

onMounted(() => {
  loadConfig();
});

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: formData,
      rules: rules,
      "label-width": "150px",
      class: "config-form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "本店须知图片",
          prop: "store"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_upload, {
                class: "image-uploader",
                action: uploadUrl.value,
                headers: uploadHeaders.value,
                name: "files",
                "show-file-list": false,
                "on-success": handleStoreSuccess,
                "before-upload": beforeUpload
              }, {
                default: _withCtx(() => [
                  (formData.store)
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        src: getFullUrl(formData.store),
                        class: "uploaded-image",
                        fit: "contain"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_el_icon, {
                        key: 1,
                        class: "upload-icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Plus))
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["action", "headers"]),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "upload-tip" }, "点击上传本店须知图片", -1))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "规则图片",
          prop: "rule"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_upload, {
                class: "image-uploader",
                action: uploadUrl.value,
                headers: uploadHeaders.value,
                name: "files",
                "show-file-list": false,
                "on-success": handleRuleSuccess,
                "before-upload": beforeUpload
              }, {
                default: _withCtx(() => [
                  (formData.rule)
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        src: getFullUrl(formData.rule),
                        class: "uploaded-image",
                        fit: "contain"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_el_icon, {
                        key: 1,
                        class: "upload-icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Plus))
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["action", "headers"]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "upload-tip" }, "点击上传规则图片", -1))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _unref(handleSave),
              loading: saving.value
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" 保存配置 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "loading"]),
            _createVNode(_component_el_button, {
              onClick: handleReset,
              loading: resetting.value
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" 重置为默认 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})